import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Container } from 'reactstrap';

import HeaderNavbar from 'components/molecules/navbar';
import HeaderNavbarMobile from 'components/molecules/navbar/mobile';
import path from 'constants/paths';
import { isMobile } from 'utils/deviceHelper';
import { filterRoutes } from 'utils/accessManager/index';
import { PLATFORM_MODE_RPM } from 'utils/accessManager/constants';
import useUser from 'utils/useUser';

const patientsOptions = [
  {
    label: 'Overview dashboard',
    link: path.dashboard,
    dataCy: 'nav-patients__dashboard',
  },
  {
    label: "Patient's details",
    link: path.patientDetails,
    dataCy: 'nav-patients__details',
  },
];

const adminPanelOptions = [
  {
    label: 'Agencies',
    link: path.adminAgencies,
    dataCy: 'nav-admin__agencies',
  },
  {
    label: 'Agency Users',
    link: path.adminAgencyDoctorList,
    dataCy: 'nav-admin__agency-users',
  },
  {
    label: 'Clinics',
    link: path.adminClinics,
    dataCy: 'nav-admin__clinics',
  },
  {
    label: 'Patients',
    link: path.adminPatients,
    dataCy: 'nav-admin__patients',
  },
  {
    label: 'Users',
    link: path.adminUsers,
    dataCy: 'nav-admin__users',
  },
];

const practiceOptions = [
  {
    label: 'Activity',
    link: path.activityReport,
    dataCy: 'nav-practice__activity-report',
  },
  {
    label: 'Adherence',
    link: path.adherenceReport,
    dataCy: 'nav-practice__adherence-report',
  },
  {
    label: 'Adherence 30 Days',
    link: path.adherenceReportLast30Days,
    dataCy: 'nav-practice__adherence-30-days-report',
  },
  {
    label: 'CCM Billing',
    link: path.ccmBillingReport,
    dataCy: 'nav-practice__ccb-billing',
  },
  {
    label: 'CCM Interactive Time',
    link: path.ccmInteractiveTimeReport,
    dataCy: 'nav-practice__ccb-interactive-time-report',
  },
  {
    label: 'Clinical Metrics',
    link: path.clinicalMetrics,
    dataCy: 'nav-practice__clinical-metrics',
  },
  {
    label: 'Daily Reading Compliance',
    link: path.complianceReport,
    dataCy: 'nav-practice__compliance-report',
  },
  {
    label: 'Interactive Time',
    link: path.interactiveTime,
    dataCy: 'nav-practice__interactive-time-report',
  },
  {
    label: 'Medicare Billing',
    link: path.medicareBilling,
    dataCy: 'nav-practice__medicare-billing',
  },
  {
    label: 'Monthly Interaction Status',
    link: path.interactionStatus,
    dataCy: 'nav-practice__monthly-interactive-status',
  },
  {
    label: 'Onboarding Status',
    link: path.onboardingStatus,
    dataCy: 'nav-practice__onboarding-status',
  },
  {
    label: 'Patients Status',
    link: path.patientsStatusReport,
    dataCy: 'nav-practice__patients-status-report',
  },
  {
    label: 'Performance Review',
    link: path.performanceReview,
    dataCy: 'nav-practice__performance-review',
  },
  // {
  //   label: 'Practice Overview',
  //   link: path.practiceOverview,
  //   dataCy: 'nav-practice__practice-overview',
  // },
  {
    label: "Yesterday's Statistics",
    link: path.statisticsReport,
    dataCy: 'nav-practice__yesterdays-statistics',
  },
];
const formsOptions = [
  {
    label: 'BAA',
    link: path.BAA,
    dataCy: 'nav-forms__baa',
    type: 'windows-link',
  },
  {
    label: 'Patient Referral',
    link: path.patientReferral,
    dataCy: 'nav-forms__patient-referral',
    type: 'windows-link',
  },
  {
    label: 'W9 ',
    link: path.W9,
    dataCy: 'nav-forms__w9',
    type: 'windows-link',
  },
];
const profileOptions = [
  {
    label: 'My Profile',
    link: path.profile,
    dataCy: 'nav-profile__profile',
  },
];

const Header = ({ disableNavigation }) => {
  const user = useUser();
  const deviceType = useSelector((state) => state.user.deviceType);
  const mode = user.platformMode;

  let filteredPracticeOptions = filterRoutes(user, practiceOptions);
  let filteredPatientsOptions = filterRoutes(user, patientsOptions);
  const filteredAdminPanelOptions = filterRoutes(user, adminPanelOptions);
  const ccmOptions = [path.ccmBillingReport, path.ccmInteractiveTimeReport];

  if (mode === PLATFORM_MODE_RPM) {
    filteredPracticeOptions = filteredPracticeOptions.filter(
      (item) => !ccmOptions.includes(item.link),
    );
  } else {
    filteredPracticeOptions = filteredPracticeOptions.filter((item) =>
      ccmOptions.includes(item.link),
    );
    filteredPatientsOptions = filteredPatientsOptions.filter(
      (item) => item.link === path.dashboard,
    );
  }

  if (window.location.pathname.includes('/ccm/consent/')) return null;
  return (
    <div className="header">
      <Container>
        {isMobile(deviceType) && (
          <HeaderNavbarMobile
            formsOptions={formsOptions}
            practiceOptions={filteredPracticeOptions}
            patientsOptions={filteredPatientsOptions}
            adminPanelOptions={filteredAdminPanelOptions}
            disableNavigation={disableNavigation}
          />
        )}
        {!isMobile(deviceType) && (
          <HeaderNavbar
            adminPanelOptions={filteredAdminPanelOptions}
            formsOptions={formsOptions}
            practiceOptions={filteredPracticeOptions}
            patientsOptions={filteredPatientsOptions}
            profileOptions={profileOptions}
            firstName={user.firstName}
            lastName={user.lastName}
            title={user.title}
            disableNavigation={disableNavigation}
          />
        )}
      </Container>
    </div>
  );
};

Header.propTypes = {
  disableNavigation: PropTypes.bool,
};

export default Header;
